import React, { useEffect } from "react";

import { Provider } from "react-redux";

import Router from "./2_router";
import { mobileStore } from "./store";
import { bootstrapOffline } from "modules/offline";

export { mobileStore };

const Entry = (props) => {
  useEffect(() => {
    bootstrapOffline(mobileStore);
  }, []);

  return (
    <Provider store={mobileStore}>
      <Router {...props} />
    </Provider>
  );
};

export default Entry;
